import { Component, inject } from '@angular/core';
import { ItemWithSelection } from '@app/shared/models/item-with-selection';
import {
  Item,
  ListView,
  ListViewProviderDirective,
  ServerItemAction,
  Util
} from '@ntap/core';
import { filter, first, map, Observable, of, switchMap } from 'rxjs';

/**
 * Reusable action that works either with a list of items as HEADING_ITEM action implementation
 * or ITEM_DIALOG action implementation
 */
@Component({
  selector: 'app-list-and-detail-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class ListAndDetailActionComponent extends ServerItemAction {
  protected parentListViewProvider: ListViewProviderDirective<ListView> | null =
    inject(ListViewProviderDirective, { optional: true });

  override doExecuteWithItem(item: Item): Observable<any> {
    if (this.parentListViewProvider) {
      return this.executeWithSelectedItems(this.parentListViewProvider, item);
    } else {
      return super.doExecuteWithItem(item);
    }
  }

  private executeWithSelectedItems(
    listViewProvider: ListViewProviderDirective<ListView>,
    item: object
  ): Observable<any> {
    return listViewProvider.selectedItems$.pipe(
      first(),
      filter((selected) => selected.length > 0),
      switchMap((selected) => {
        const itemWithSelected: ItemWithSelection = Object.assign({}, item, {
          $selected: Util.mapToBasicItemData(selected),
          $listName: listViewProvider.viewName
        });
        return super.doExecuteWithItem(itemWithSelected);
      })
    );
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.parentListViewProvider
      ? this.parentListViewProvider.selectedItems$.pipe(
          map((selected) => selected.length <= 0)
        )
      : of(false);
  }
}
